'use strict';
var globalThis = require('../internals/global-this');

module.exports = globalThis.Promise;



//////////////////
// WEBPACK FOOTER
// ./node_modules/twilsock/node_modules/core-js/internals/promise-native-constructor.js
// module id = 822
// module chunks = 25